import { render, staticRenderFns } from "./FreshwaterPricingForm.vue?vue&type=template&id=70678d61&"
import script from "./FreshwaterPricingForm.vue?vue&type=script&lang=js&"
export * from "./FreshwaterPricingForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports